import { TFunction } from 'i18next'

import { MapPageError } from '@/store/cartSlice/selectors/mapPageErrorsSelector'
import {
  ConstraintScope,
  getReservationConstraintMessage,
} from '@/utils/getReservationConstraintMessage'

export function getMapPageErrorAnchor(error: MapPageError): string {
  switch (error.type) {
    case 'globalMinQty':
    case 'globalMaxQty':
      return 'global-reservation'
    case 'globalSpotMinQty':
    case 'globalSpotMaxQty':
      return 'global-spot'
    case 'groupMinQty':
    case 'groupMaxQty':
      return `group-${error.groupId}-reservation`
    case 'spotMinQty':
    case 'spotMaxQty':
      return `group-${error.groupId}-spot`
    case 'minQty':
    case 'maxQty':
      return `service-${error.serviceId}`
    default:
      return 'global-reservation'
  }
}

export function getMapPageErrorMessage(
  t: TFunction,
  error: MapPageError
): string | null {
  switch (error.type) {
    case 'minQty':
      return t(`ticketErrorsWithServiceName.${error.type}`, {
        min: error.minQty,
        serviceName: error.serviceName,
      })
    case 'maxQty':
      return t(`ticketErrorsWithServiceName.${error.type}`, {
        max: error.maxQty,
        serviceName: error.serviceName,
      })
    case 'globalMinQty':
      return getReservationConstraintMessage(
        t,
        { minimumQuantity: error.minQty },
        'total'
      )
    case 'globalMaxQty':
      return getReservationConstraintMessage(
        t,
        { maximumQuantity: error.maxQty },
        'total'
      )
    case 'globalSpotMinQty':
      return getReservationConstraintMessage(
        t,
        { minimumQuantity: error.minQty },
        'spot'
      )
    case 'globalSpotMaxQty':
      return getReservationConstraintMessage(
        t,
        { maximumQuantity: error.maxQty },
        'spot'
      )
    case 'groupMinQty':
      return getReservationConstraintMessage(
        t,
        { minimumQuantity: error.minQty },
        'groupReservation'
      )
    case 'groupMaxQty':
      return getReservationConstraintMessage(
        t,
        { maximumQuantity: error.maxQty },
        'groupReservation'
      )
    case 'spotMinQty':
      return getReservationConstraintMessage(
        t,
        { minimumQuantity: error.minQty },
        'groupSpot'
      )
    case 'spotMaxQty':
      return getReservationConstraintMessage(
        t,
        { maximumQuantity: error.maxQty },
        'groupSpot'
      )
    default:
      return null
  }
}

export function scrollToMapPageErrorAnchor(anchor: string) {
  document
    .querySelector(`[data-ticket-error-anchor="${anchor}"]`)
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

export type TicketConstraintLinesProps = {
  constraintClassName?: string
  constraintScope: ConstraintScope
  errorAnchor: string
  hasMaxError?: boolean
  hasMinError?: boolean
  maximumQuantity?: number
  minimumQuantity?: number
}
